let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("en17r")).then(() => parcelRequire('lx41M'));